import { api } from './api.ts';
import { useAsync } from './useAsync.ts';

export interface CollectionEntry {
  id: string;
  date: string; // YYYY-MM-DD
  // JSON bruto da coleta: cada bloco traz a própria fonte e janela.
  data: Record<string, any>;
}

/** Seções do painel que uma coleta pode ter atualizado (campo `covers` do JSON da coleta). */
export type Section = 'concorrencia' | 'metricas' | 'perfil' | 'youtube' | 'x' | 'linktree';

export interface Collections {
  /** Coletas arquivadas, da mais recente para a mais antiga. */
  entries: CollectionEntry[];
  /** A coleta mais recente de todas. */
  newest: CollectionEntry | null;
  /** A coleta mais recente que traz o bloco pedido: o dado antigo continua na tela até outra coleta trazê-lo. */
  latestWith: (block: string) => CollectionEntry | null;
  /** O selo "Novo" só vale para o que a coleta mais recente de todas atualizou. */
  isNew: (section: Section) => boolean;
  /** Atalho para cartões: "Novo" só se o cartão vem da coleta mais recente e ela cobre a seção. */
  showNew: (section: Section, entry: CollectionEntry | null) => boolean;
}

export function useCollections(): Collections {
  const result = useAsync(() => api.get<CollectionEntry[]>('/audit/collections/all'), []);
  const entries = result.data ?? [];
  const newest = entries[0] ?? null;
  const covers: string[] = Array.isArray(newest?.data.covers) ? newest.data.covers : [];
  const isNew = (section: Section): boolean => covers.includes(section);
  return {
    entries,
    newest,
    latestWith: (block) => entries.find((e) => e.data[block] !== undefined) ?? null,
    isNew,
    showNew: (section, entry) => entry !== null && entry.id === newest?.id && isNew(section),
  };
}
